import { useState } from 'react';

/** The share link is the whole access-control story, so say so plainly. */
export default function ShareBox({ url, compact = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // Clipboard API needs a secure context; fall back to a selection.
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="stack gap-8">
      <div className="share-box">
        <span className="share-url">{url}</span>
        <button type="button" className="btn btn-sm btn-primary" onClick={copy}>
          {copied ? '✓ Copie' : 'Copier'}
        </button>
      </div>
      {!compact && (
        <p className="small faint">
          Toute personne disposant de ce lien peut voir la sortie et s'y inscrire. Il est impossible a
          deviner, mais partagez-le uniquement avec le club.
        </p>
      )}
    </div>
  );
}
